import { observer } from 'mobx-react-lite';

import { MiniatureMessageLayout } from 'APP/main/ChatView/components/MiniatureMessageLayout/MiniatureMessageLayout';

import usePresenter from './presenter';

const Article = ({
  titleClassName,
  textClassName,
  iconClassName,
  message,
  title,
  onClick,
  preventInteraction,
}) => {
  const presenter = usePresenter({ message });

  if (!message) {
    return null;
  }

  return (
    <MiniatureMessageLayout
      titleClassName={titleClassName}
      textClassName={textClassName}
      iconClassName={iconClassName}
      imageUrl={presenter.imageUrl}
      title={title}
      text={presenter.title}
      messageId={message.id}
      onClick={onClick}
      preventInteraction={preventInteraction}
    />
  );
};

export default observer(Article);
